















import { Component, Vue } from 'vue-property-decorator';
import social from '@/components/social.vue';
import dc from '@/components/dc.vue';
@Component({
  components: {
    social,
    dc,
  },
})
export default class Home extends Vue {}
